import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import * as Yup from 'yup';


import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { PostLimitData, getAccountDetails, getBankName } from '../../../../../../Axios/LimitManagement';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useParams } from 'react-router';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';



const Online = (props) => {
  const [PostBankDetails, setPostBankDetails] = useState(null)
  const [openAlert, setOpenAlert] = useState(false)
  const [alertType, setAlertType] = useState('success')
  const [alertMessage, setAlertMessage] = useState(null)
  const [BankDetails, setBankDetails] = useState(null)
  const [AccountDetails, setAccountDetails] = useState(null)
  const [openLoader, setOpenLoader] = useState(false)

  const params = useParams();


  const [topuptype, setTopuptype] = useState(props.topupMode)
  const [InitialValues, setInitialValues] = useState(
    null
  )

  useEffect(() => {
    if (props.topupMode !== localStorage.getItem('topup_mode') && !localStorage.getItem('refreshed')) {
      localStorage.setItem('refreshed', true)
      localStorage.setItem('topup_mode', props.topupMode)
      window.location.reload();
    }
    else {
      localStorage.setItem('refreshed', false)
    }
  }, [props.topupMode])

  useEffect(() => {
    setTopuptype(params.type)
    setInitialValues({
      bene: '',
      bene_account: '',
      topup_mode: props.topupMode,
      origin_name: '',
      origin_bank: '',
      transfer_date: '',
      ref_data: '',
      amount: '',
      bank_recipt: '',
      bank_name: '',
      cmd_address: '',
      branch_name: '',
      branch_code: '',
      State: '',
      district: '',
      city: '',
      mobile: '',
      txn_ref_no: '',
      originator_account_number: '',
      upi_ref_no: '',
      upi_id: '',
      remarks: '',
    })



  }, [params.type])
  console.log("type", topuptype);






  useEffect(() => {
    getBankName(setBankDetails)
  }, [])


  console.log("BankDetails", BankDetails);

  // const handleOptionChange = (event) => {
  //   setAge(event.target.value);
  // };

  const hendleAccountChange = (value, setFieldValue) => {
    let data = AccountDetails.message[value];
    setFieldValue('bank_name', data.bank_name)
    setFieldValue('originator_account_number', data.bank_details)
    setFieldValue('userBank_id', data.id)
    setFieldValue('origin_name', data.agent_name)
  }

  const handleBankChange = (index, setFieldValue) => {
    setFieldValue('bene_account', BankDetails[index].account_no)
    setFieldValue('bene', BankDetails[index].bank_name)
    setFieldValue('fia_bank_id', BankDetails[index].bank_id)
    setPostBankDetails(BankDetails[index])
    console.log("adas", BankDetails[index]);
  }

  useEffect(() => {
    getAccountDetails(setAccountDetails, 'online_bank', setOpenAlert, setAlertType, setAlertMessage)
  }, [])


  console.log("Account details", AccountDetails);



  const handlepostRequest = (data, setFieldValue) => {
    PostLimitData(PostBankDetails, data, setOpenAlert, setAlertType, setAlertMessage,setOpenLoader,setFieldValue)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };

  console.log(PostBankDetails);

  return (
    <div style={{ height: '60vh', paddingBottom: useMediaQuery('(max-width:600px)') ? '100px' : '0px', overflowY: 'scroll', scrollbarWidth: 'none', marginLeft: '18px' }}>
      {
        InitialValues &&
        <Formik
          initialValues={InitialValues}

          validationSchema={
            Yup.object().shape(
              {
                bene: Yup.string().required("This is required"),
                bene_account: Yup.string().required("This is required"),
                topup_mode: Yup.string().required("This is required"),
                origin_name: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM', 'Online Transfer', 'UPI'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),

                amount: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM', 'Online Transfer', 'UPI'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                transfer_date: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM', 'Online Transfer', 'UPI'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                origin_bank: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                branch_name: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                branch_code: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                txn_ref_no: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Online Transfer'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                originator_account_number: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Online Transfer'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                bank_name: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Online Transfer', 'Cheque', 'UPI'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                bank_recipt: Yup.string().when('topup_mode', {
                  is: (topup_mode) => ['Cash', 'CDM'].includes(topup_mode),
                  then: Yup.string().required('This is required'),
                }),
                cmd_address: Yup.string().when('topup_mode', {
                  is: 'CDM',
                  then: Yup.string().required('This is required'),
                }),
                State: Yup.string().when('topup_mode', {
                  is: 'CDM',
                  then: Yup.string().required('This is required'),
                }),
                district: Yup.string().when('topup_mode', {
                  is: 'CDM',
                  then: Yup.string().required('This is required'),
                }),
                city: Yup.string().when('topup_mode', {
                  is: 'CDM',
                  then: Yup.string().required('This is required'),
                }),
                mobile: Yup.string().when('topup_mode', {
                  is: 'CDM',
                  then: Yup.string().required('This is required'),
                }),
                upi_id: Yup.string().when('topup_mode', {
                  is: 'UPI',
                  then: Yup.string().required('This is required'),
                }),
                upi_ref_no: Yup.string().when('topup_mode', {
                  is: 'UPI',
                  then: Yup.string().required('This is required'),
                })
              }
            )
          }
          onSubmit={async (values, { setSubmitting }) => {
            console.log("hitted");
            try {


              // If validation passes, proceed with form submission
              // handlepostRequest({ ...values})
              setSubmitting(false);
              // Your form submission logic here...
            } catch (error) {
              // Handle validation errors
              console.error('Validation error:', error);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            isValid,

            /* and other goodies */

          }) => (
            <form onSubmit={handleSubmit} style={{ marginBlock: '50px' }}>
              <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert
                  onClose={handleClose}
                  severity={alertType}
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {alertMessage}
                </Alert>
              </Snackbar>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Grid container spacing={2}>
                <Grid item xl={4} md={6} sm={12} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">FIA Bank</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={values.bene}
                      error={errors.bene && touched.bene}
                      name='bene'
                      label="Bene Bank"
                      onChange={(e) => handleBankChange(e.target.value, setFieldValue)}
                    >
                      <MenuItem value={values.bene} >{values.bene}</MenuItem>
                      {

                        BankDetails && BankDetails.map((row, index) => (
                          <MenuItem value={index} key={index}>{row.bank_name}</MenuItem>
                        ))
                      }

                    </Select>
                  </FormControl>
                  <Typography sx={{ color: 'red' }} variant='subtitle'>
                    {errors.bene && touched.bene && errors.bene}
                  </Typography>
                </Grid>

                <Grid item xl={4} md={6} sm={12} xs={12}>
                  <TextField
                    type="text"
                    fullWidth
                    name="bene_account"
                    disabled
                    label="FIA Account"
                    error={errors.bene_account && touched.bene_account}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.bene_account}
                  />
                  <Typography sx={{ color: 'red' }} variant='subtitle'>
                    {errors.bene_account && touched.bene_account && errors.bene_account}
                  </Typography>
                </Grid>


                {

                  props.topupMode === "Online Transfer" ?
                    <>
                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Bank Name</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={values.bank_name}
                            error={errors.bank_name && touched.bank_name}
                            name='bank_name'
                            label="Bank Name"
                            onChange={(e) => hendleAccountChange(e.target.value, setFieldValue)}
                          >
                            <MenuItem value={values.bank_name} >{values.bank_name}</MenuItem>
                            {

                              AccountDetails && AccountDetails.message.map((row, index) => (
                                <MenuItem value={index} key={index}>{row.bank_name}</MenuItem>
                              ))
                            }

                          </Select>
                        </FormControl>
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.bene && touched.bene && errors.bene}
                        </Typography>
                      </Grid>

                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          name="origin_name"
                          disabled
                          label="Agent name"
                          error={errors.origin_name && touched.origin_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.origin_name}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.origin_name && touched.origin_name && errors.origin_name}
                        </Typography>
                      </Grid>

                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          name="amount"
                          label="Amount"
                          error={errors.amount && touched.amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.amount}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.amount && touched.amount && errors.amount}
                        </Typography>
                      </Grid>

                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="date"
                          fullWidth
                          focused
                          name="transfer_date"
                          label="Transfer/Deposit date"
                          error={errors.transfer_date && touched.transfer_date}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.transfer_date}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.transfer_date && touched.transfer_date && errors.transfer_date}
                        </Typography>
                      </Grid>






                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          name="txn_ref_no"
                          label="Txn Ref No."
                          error={errors.txn_ref_no && touched.txn_ref_no}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.txn_ref_no}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.txn_ref_no && touched.txn_ref_no && errors.txn_ref_no}
                        </Typography>
                      </Grid>



                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          disabled
                          name="originator_account_number"
                          label="Originator Account Number"
                          error={errors.originator_account_number && touched.originator_account_number}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.originator_account_number}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.originator_account_number && touched.originator_account_number && errors.originator_account_number}
                        </Typography>
                      </Grid>

                      <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          name="remarks"
                          label="Remarks"
                          error={errors.remarks && touched.remarks}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.remarks}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.remarks && touched.remarks && errors.remarks}
                        </Typography>
                      </Grid>

                    </>

                    :
                    null
                }




                <Grid display='flex' item xl={12} lg={12} md={12} sm={12} xs={12} justifyContent='flex-end'>
                  <Button variant='contained' size='small' color='secondary' disabled={isSubmitting || !isValid?true:false} onClick={!isSubmitting && isValid ? () => handlepostRequest({ ...values }, setFieldValue) : null}>
                    Submit
                  </Button>
                  <>{console.log(errors)}</>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      }

    </div>
  )

};

export default Online;


